export default (domain, locale) => {
  return ({ item }) => {
    const isSameDomainExternalLink = item.target && item.target.type === 'externalLink' && item.target.href.includes(domain) && !item.target.href.includes('mailto')
    const isLocalisedLink =
      item.target && item.target.href && (item.target.href.match(/\/[a-z]{2}-[a-z]{2}\//) || item.target.href.match(/\/[a-z]{2}\/[a-z]{2}\//))
    const shouldInjectLocale = isSameDomainExternalLink && !isLocalisedLink

    if (!shouldInjectLocale) return { item }

    const originalUrl = item.target.href
    const urlParts = originalUrl.split(domain)
    const newUrl = `${urlParts[0]}${domain}/${locale.toLowerCase()}${urlParts[1]}`

    return {
      item: {
        ...item,
        href: newUrl,
        target: {
          ...item.target,
          href: newUrl
        }
      }
    }
  }
}
